module.exports = __webpack_public_path__ + "static/media/Fabio&Mirian_Ficha de Projeto_INT.58f2330f.pdf";